import { useEffect, useState } from 'react';

import { ProgressBar, Text } from 'shell/components';

const ProgressBarDemo = () => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((current) => {
                if (current === 100) {
                    return 0;
                }
                const diff = Math.random() * 10;
                return Math.min(current + diff, 100);
            });
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, []);

    return (
        <>
            <Text variant={'sh1'}>Progress</Text>
            <ProgressBar value={progress} />
        </>
    );
};

export default ProgressBarDemo;
